import {
  FETCH_ANALYTICS_FAILURE,
  FETCH_ANALYTICS_REQUEST,
  FETCH_ANALYTICS_SUCCESS,
  SET_ANALYTICS_PAGE,
  SET_ANALYTICS_PAGE_SIZE,
} from '../actions/DataAnalyticsActions';

const initialState = {
  loading: false,
  data: [],
  totalData: 0,
  page: 1,
  pageSize: 10,
  error: null,
};

const dataAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ANALYTICS_REQUEST:
      return { ...state, loading: true };
    case FETCH_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        totalData: action.payload.totalData,
      };
    case FETCH_ANALYTICS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_ANALYTICS_PAGE:
      return { ...state, page: action.payload };
    case SET_ANALYTICS_PAGE_SIZE:
      return { ...state, pageSize: action.payload, page: 1 };
    default:
      return state;
  }
};

export default dataAnalyticsReducer;
